import React from "react";

export default function AssetStatusCards() {
	const assetData = [
		{
			label: "Field device",
			count: 0,
			icon: "ki-duotone ki-devices",
			color: "text-primary",
		},
		{
			label: "Controller",
			count: 14,
			icon: "ki-duotone ki-setting-2",
			color: "text-success",
		},
		{
			label: "SCADA,HMI",
			count: 5,
			icon: "ki-duotone ki-monitor-mobile",
			color: "text-info",
		},
		{
			label: "EWS,Historian",
			count: 0,
			icon: "ki-duotone ki-chart-line-star",
			color: "text-warning",
		},
		{
			label: "Computer",
			count: 1,
			icon: "ki-duotone ki-laptop",
			color: "text-danger",
		},
		{
			label: "Network device",
			count: 1,
			icon: "ki-duotone ki-router",
			customColor: "#7239ea",
		},
		{
			label: "Others",
			count: 40,
			icon: "ki-duotone ki-abstract-26",
			customColor: "#50cd89",
		},
	];

	return (
		<div className="mb-3 mt-5">
			<div className="row g-2">
				{assetData.map((asset, idx) => (
					<div key={idx} className="col">
						<div className="card h-lg-100">
							<div className="card-body d-flex justify-content-between align-items-start flex-column py-4 px-6">
								<div className="m-0">
									{asset.customColor ? (
										<i
											className={`${asset.icon} fs-2hx`}
											style={{ color: asset.customColor }}
										>
											<span className="path1"></span>
											<span className="path2"></span>
										</i>
									) : (
										<i className={`${asset.icon} fs-2hx ${asset.color}`}>
											<span className="path1"></span>
											<span className="path2"></span>
											<span className="path3"></span>
											<span className="path4"></span>
											<span className="path5"></span>
										</i>
									)}
								</div>
								<div className="d-flex flex-column my-3 mb-0">
									<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">
										{String(asset.count).padStart(2, "0")}
									</span>
									<div className="m-0">
										<span className="fw-semibold fs-6 text-gray-500">
											{asset.label}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
